import { BaseModel } from './BaseModel';

export class Status extends BaseModel {
  static NOT_SUBMITTED = 'Not Submitted';
  static FEEDBACK = 'Feedback';
  static PASSED = 'Passed';
  static REVIEW_PENDING = 'Review Pending';
  static NOT_YET = 'Not Yet';

  static get entity() {
    return 'statuses';
  }

  static get fk() {
    return 'status_id';
  }

  static fields() {
    return {
      id: this.uid(),
      name: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null),
      delete_at: this.attr(null)
    };
  }

  get isNotSubmitted() {
    return this.isStatus(Status.NOT_SUBMITTED);
  }

  get isReviewPending() {
    return this.isStatus(Status.REVIEW_PENDING);
  }

  get isFeedback() {
    return this.isStatus(Status.FEEDBACK);
  }

  get isPassed() {
    return this.isStatus(Status.PASSED);
  }

  get isNotYet() {
    return this.isStatus(Status.NOT_YET);
  }

  static get notSubmitted() {
    return Status.name(Status.NOT_SUBMITTED);
  }

  static get reviewPending() {
    return Status.name(Status.REVIEW_PENDING);
  }

  static get passed() {
    return Status.name(Status.PASSED);
  }

  static get notYet() {
    return Status.name(Status.NOT_YET);
  }

  static assessmentStatus() {
    return [
      Status.name(Status.REVIEW_PENDING),
      Status.name(Status.NOT_SUBMITTED),
      Status.name(Status.FEEDBACK),
      Status.name(Status.PASSED)
    ];
  }

  static grantObemStatus() {
    return [Status.name(Status.NOT_YET), Status.name(Status.PASSED)];
  }

  static name(name) {
    return Status.query().where('name', name).first();
  }

  isStatus(name) {
    return this.name && this.name === name;
  }

  static apiConfig = {
    actions: {
      fetch() {
        return this.get(`/statuses`);
      },

      fetchByStatusId(id) {
        return this.get(`/statuses/${id}`);
      }
    }
  };
}

export default Status;
